export default class BrowserDetect {
    userAgent;
    browserInfo;
    constructor() {
        this.userAgent = window.navigator.userAgent;
        this.browserInfo = this.getBrowserInfo();
        this.handleIE();
    }
    getBrowserInfo() {
        let ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: 'IE ', version: (tem[1] || '') };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\bOPR\/(\d+)/);
            if (tem != null) {
                return { name: 'Opera', version: tem[1] };
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return {
            name: M[0],
            version: M[1]
        };
    }
    handleIE() {
        // Detect versions below ie11
        let msie = this.userAgent.indexOf('MSIE ');
        const ielt11 = msie > 0;
        // Detect ie11
        const ie11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
        // If Internet Explorer
        if (ielt11 || ie11) {
            // Default version
            let version = 11;
            // Way to detect version < 11
            if (ielt11)
                version = parseInt(this.userAgent.substring(msie + 5, this.userAgent.indexOf(".", msie)));
            // Append classes to HTML
            document.getElementsByTagName('html')[0].classList.add('ie');
            document.getElementsByTagName('html')[0].classList.add('v' + version);
            // window.getScript('https://polyfill.io/v3/polyfill.min.js?features=Promise%2CObject.assign%2CString.prototype.includes%2CNumber.isNaN');
        }
    }
}
